import React, { Component } from 'react';
import './index.scss';
import CustomBanner from '../../components/CustomBanner';
import { ReactComponent as BarCode } from '../../assets/images/bar-code-icon.svg';
import { ReactComponent as AlertIcon } from '../../assets/images/alert-icon.svg';
import * as API from '../../configuration/apiconfig';
import Loader from '../loader';
import BarCodeModal from '../../components/BarcodeModal';
import { showAlert } from '../../components/showAlert';
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
      voucherImage: '',
      voucherNumber: '',
      barcodeModalSH: false,
      scanBarcodeLoaderMsg: 'Barcode scanning in progress',
    };
  }

  componentDidMount = async () => {
    window.winvar = this;
    await this.getVoucherImageData();
    localStorage.removeItem('vouchersScanned');
    localStorage.getItem('orderId') != null && localStorage.removeItem('orderId');
  };

  getVoucherImageData = async () => {
    API.callEndpoint('GET', 'Bearer', '/cms/v2/packs/add-voucher-hero-banner-image')
      .then(response => {
        if (response.data.length) {
          var getImage = response.data[0].packs_items[0].packs_items_images.filter(item => item.code == 'x945y436');
          if (getImage.length) {
            this.setState({ voucherImage: getImage[0].imageurl });
          }
        }
        this.setState({ loader: false });
      })
      .catch(err => {
        this.setState({ loader: false });
        console.log(err.error);
        showAlert({
          html: `<p>${err.error}</p>`,
          iconHtml: <AlertIcon />,
          showConfirmButton: true,
          confirmButtonText: 'OK',
          allowEscapeKey: false,
          iconClasses: 'borderless',
          onConfirm: () => { },
        });
      });
  };

  checkVoucherNumber = async () => {
    var getvoucherNumber = this.state.voucherNumber;
    console.log('the getvoucherNumber is', getvoucherNumber);
    const cinemaId = localStorage.getItem('cinemaid');
    console.log('localStorage.getItem(cinemaid)', cinemaId);
    API.callEndpoint('POST', 'Bearer', '/order/v2/orders/validate-voucher', { vouchercode: getvoucherNumber, cinemaid: cinemaId })
      .then(response => {
        console.log('response from voucher ', response);
        var responseData = { ...response.data, vouchercode: getvoucherNumber };
        var vouchersScannedList = localStorage.getItem('vouchersScanned');
        if (vouchersScannedList === null) {
          var vouchersScannedArr = [];
          vouchersScannedArr.push(responseData);
          localStorage.setItem('vouchersScanned', JSON.stringify(vouchersScannedArr));
          window.location.href = '/yourvouchers';
        }
        // // // // // this.setState({loader: false});
      })
      .catch(error => {
        this.setState(
          {
            // // // // // loader: false,
            barcodeModalSH: false,
            scanBarcodeLoaderMsg: 'Barcode scanning in progress',
          },
          () => {
            console.log(error.error);
            console.log('--------------------', error);

            showAlert({
              html: `<p>${error.error}</p>`,
              iconHtml: `<img src=${AlertIcon}>`,
              showConfirmButton: true,
              confirmButtonText: 'OK',
              allowOutsideClick: false,
              allowEscapeKey: false,
              iconClasses: 'borderless',
              onConfirm: () => { },
            });
          }
        );
      });
  };

  addvoucherBackBtn = () => {
    window.location.href = `/login`;
  };

  skipVouchers = async () => {
    // When session expiry in login user > delete order
    if (localStorage.getItem('sessionExpiredRedirectUrl') != null && localStorage.getItem('orderId') != null) {
      this.setState({
        loader: true,
      });
      var orderDetails = JSON.parse(localStorage.getItem('orderId'));
      await API.callEndpoint('DELETE', 'Bearer', `/order/v2/orders/${orderDetails.id}`)
        .then(response => {
          localStorage.removeItem('selectedSeats');
          localStorage.removeItem('orderId');
          localStorage.removeItem('cartData');
          localStorage.removeItem('sessionExpiredRedirectUrl');
          this.setState({ loader: false });
        })
        .catch(err => {
          console.log(err.error, 'delete error');
          this.setState({ loader: false });
        });
    }

    const isFnbFlow = localStorage.getItem('orderType') === 'fnb';
    const cinemaId = localStorage.getItem('cinemaid');
    if (isFnbFlow) {
      window.location.href = `fnb?cinemaid=${cinemaId}`;
    } else {
      var getSessionIdFromLocalstorage = localStorage.getItem('sesstionid');
      window.location.href = `/seatlayout?sessionid=${getSessionIdFromLocalstorage}`;
    }
  };

  scanBarCodeClick = () => {
    window.callbackObj.callEnableBarcodeScan('voucher', window.constant.VOUCHER_CODE_LENGTH);
    this.setState({
      barcodeModalSH: true,
      loginErrorMsg: '',
      scanBarCodeBtnClick: true,
      manualBarCodeBtnClick: false,
    });
  };

  GetCardInfo = scanData => {
    if (scanData) {
      this.setState(
        {
          voucherNumber: scanData,
          scanBarcodeLoaderMsg: 'Fetching Voucher Info',
        },
        () => {
          window.callbackObj.callDisableBarcodeScan();
          this.checkVoucherNumber();
        }
      );
    }
  };

  AbortTransactionResponse = response => {
    // This is dot net function
    console.log(response, 'Swipe card abort response--login page');
  };

  disableSubmitBtn = () => {
    var disabled = true;
    if (this.state.memberCardNumber != '') {
      disabled = false;
    } else {
      disabled = true;
    }
    return disabled;
  };

  closeIconClick = getFlow => {
    // // // // // alert("scan modal code here");
    this.setState(
      {
        barcodeModalSH: false,
        voucherNumber: '',
        scanBarCodeBtnClick: false,
        // // // // // memberCardNumber: "",
        manualBarCodeBtnClick: false,
        keyboardInputClickManually: false,
      },
      () => {
        window.callbackObj.callDisableBarcodeScan();
      }
    );
  };

  keyBoardOnChange = input => {
    this.setState({
      memberCardNumber: input,
      loginErrorMsg: '',
    });
    // console.log("Input changed", input);
  };

  keyBoardOnKeyPress = button => {
    // console.log("Button pressed", button);
    if (button === '{shift}' || button === '{lock}') this.keyBoardHandleShift();
  };

  keyBoardHandleShift = () => {
    const layoutName = this.state.layoutName;
    this.setState({
      layoutName: layoutName === 'default' ? 'shift' : 'default',
    });
  };

  clickKeyboardIcon = () => {
    this.setState(
      {
        // keyboardInputClickManually: true
        keyboardInputClickManually: !this.state.keyboardInputClickManually ? true : false,
      },
      () => {
        var getInputElem = document.getElementById('memberInput');
        if (getInputElem) {
          document.getElementById('memberInput').focus();
        }
      }
    );
  };

  render() {
    return (
      <>
        <Loader loader={this.state.loader} />
        <section className="addvoucher-page">
          <section className="addvoucher-wrapper">
            <CustomBanner
              voucherTitle={'Got a Voucher to Redeem?'}
              titleLogo={this.state.voucherImage}
              title={''}
              onBackBtnClick={() => this.addvoucherBackBtn()}
              subtitle={false}
              renderAsHtml={false}
              rewardsRedeemText="Scan any vouchers you may want to redeem now"
            />
            <section className="content">
              <div className="addVoucherComponent">
                <div className="scan-btn paddingTop">
                  <a onClick={this.scanBarCodeClick} className="btn btnPrimary" href="javascript:;" title="CLICK TO SCAN BARCODE">
                    CLICK TO SCAN BARCODE
                    {/* <img src={barCode} alt="Bar code" /> */}
                    <BarCode />
                  </a>
                </div>
                <p className="or-para">OR</p>
                <div className="skip-text">
                  <p>
                    <a onClick={this.skipVouchers} href="javascript:;" title="SKIP THIS STEP">
                      SKIP THIS STEP
                    </a>
                  </p>
                </div>
              </div>
            </section>
          </section>
        </section>
        <BarCodeModal
          parentState={this.state}
          closeIconClick={this.closeIconClick}
          keyBoardOnChange={this.keyBoardOnChange}
          keyBoardOnKeyPress={this.keyBoardOnKeyPress}
          keyBoardHandleShift={this.keyBoardHandleShift}
          clickKeyboardIcon={this.clickKeyboardIcon}
          disableSubmitBtn={this.disableSubmitBtn}
          userLogin={this.userLogin}
          keyBoardIcon={false}
        />
      </>
    );
  }
}

export default index;
